import { Card } from '@optools/components/ui/card';
import { cn } from '@optools/components/ui/utils';
import { Game } from '@optools/services/operator-gateway/types/generated/graphql';
import { formatGameDate } from '@optools/utils/datetime';
import { ReactNode } from 'react';

import { GameMatchup } from './game-matchup';

const Section = ({ children, title }: { children: ReactNode; title: ReactNode }) => {
  return (
    <div className="flex flex-col gap-1">
      <h2 className="text-sm font-bold">{title}</h2>
      <p className="relative isolate z-10 text-xs font-medium">{children}</p>
    </div>
  );
};

export interface GameCardGame {
  away: Pick<Game['away'], 'id' | 'abbreviation' | 'name' | 'shortName'>;
  feeds?: Game['feeds'];
  gameDate: Game['gameDate'];
  gamePk: Game['gamePk'];
  home: Pick<Game['home'], 'id' | 'abbreviation' | 'name' | 'shortName'>;
  status: Game['status'];
  venue: Game['venue'];
}

export interface GameCardProps {
  actionButton?: ReactNode;
  children?: ReactNode;
  className?: string;
  ['data-testid']?: string;
  game: GameCardGame;
}

export function GameCard({ actionButton, children, className, game, ...props }: GameCardProps) {
  return (
    <Card
      className={cn('col-span-full grid grid-cols-subgrid gap-0 overflow-scroll p-4', className)}
      {...props}>
      <div className="col-span-full grid grid-cols-subgrid gap-8">
        <GameMatchup awayTeam={game.away} feeds={game.feeds} homeTeam={game.home} size={40} />
        <div className="grid grid-cols-[80px_176px_176px_1fr] items-start gap-8">
          <Section title="Game PK">{game.gamePk}</Section>
          <Section title="Venue">{game.venue.name}</Section>
          <Section title="Game Date">{formatGameDate(game.gameDate)}</Section>
          <Section title="Status">{game.status}</Section>
        </div>
        {actionButton && <div className="shrink-0 justify-end">{actionButton}</div>}
      </div>
      {children && <div className="col-span-full [&>:not(a)]:mt-6">{children}</div>}
    </Card>
  );
}
